function getAd() {
  const fromLS = (() => {
    try {
      return JSON.parse(localStorage.getItem("ad"));
    } catch {
      return null;
    }
  })();

  if (fromLS) return fromLS;

  const match = document.cookie.match(/(^| )ad=([^;]+)/);
  if (match) return match[2];

  return "direct";
}

export default getAd;
